module.exports = __webpack_public_path__ + "static/media/pass-out-icon.92786a0c.svg";